import React from 'react';

import { Connect } from '@rover/react-lib/src/components/utils/Redux';
import { A11yContextProvider } from '@rover/react-lib/src/context/A11yContext';
import { selectors as frontendConfigurationSelectors } from '@rover/react-lib/src/redux/ducks/frontendConfiguration.duck';
import { selectors as petsSelectors } from '@rover/react-lib/src/redux/ducks/pets.duck';

import SearchBox from './SearchBox';
import {
  actions as searchBoxActions,
  effects as searchBoxEffects,
  selectors as searchBoxSelectors,
} from './SearchBox.duck';

export interface Props {
  className?: string;
}

const actions = {
  updateFilters: searchBoxActions.updateFilters,
};

const effects = {
  submit: searchBoxEffects.submit,
  submitTraining: searchBoxEffects.submitTraining,
};

const selector = (state) => ({
  dateRangePickerLabel: searchBoxSelectors.getDateRangePickerLabel(state),
  endDatePlaceholder: searchBoxSelectors.getEndDatePlaceholder(state),
  filters: searchBoxSelectors.getFilters(state),
  language: frontendConfigurationSelectors.getLanguage(state),
  pets: petsSelectors.getPets(state),
  petSizeBuckets: frontendConfigurationSelectors.getSettings(state).dogSizeBuckets,
  serviceType: searchBoxSelectors.getServiceType(state),
  serviceTypeOptions: searchBoxSelectors.getApplicableServiceTypeOptions(state),
  startDatePlaceholder: searchBoxSelectors.getStartDatePlaceholder(state),
  weightUnit: frontendConfigurationSelectors.getSettings(state).weightUnit,
});

// Connect.jsx is currently untyped

const SearchBoxContainer = (props: Props): JSX.Element => {
  return (
    <Connect actions={actions} effects={effects} selector={selector}>
      {(connectedProps) => (
        <A11yContextProvider>
          <SearchBox {...connectedProps} {...props} />
        </A11yContextProvider>
      )}
    </Connect>
  );
};

export default SearchBoxContainer;
